<template>
  <div>
    <!-- Start Navbar Area -->
    <div class="navbar-area navbar-style-two">
      <div class="huruma-responsive-nav">
        <div class="container">
          <div class="huruma-responsive-menu">
            <div class="logo">
              <a href="index.html">
                <img :src="logo" width="40%" class="white-logo" alt="logo" />
                <img :src="logo" width="40%" class="black-logo" alt="image" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="huruma-nav">
        <div class="container">
          <nav class="navbar navbar-expand-md navbar-light">
            <a class="navbar-brand" href="/ipdyi">
              <img :src="logo" width="90px" class="white-logo" alt="logo" />
              <img :src="logo" width="90px" class="black-logo" alt="image" />
            </a>
           <span class="ml-5 pl-5 slang ">...the uncoloured net</span>

            <div
              class="collapse navbar-collapse mean-menu"
              id="navbarSupportedContent"
            >

              <ul class="navbar-nav">
                <li class="nav-item">
                  <a :href="home" class="nav-link active">Home</a>
                </li>

                <li class="nav-item">
                  <a
                    target="_blank"
                    href="https://drive.google.com/folderview?id=0B7vFk0DueDXCTTdoU25TYlNoLVk&usp=sharing"
                    class="nav-link"
                    >Resources</a
                  >
                </li>
                <li class="nav-item">
                  <a href="#" class="nav-link">
                    About
                    <i class="bx bx-chevron-down"></i>
                  </a>
                  <ul class="dropdown-menu">
                    <li class="nav-item">
                      <a
                        href="#"
                        class="nav-link"
                        data-toggle="modal"
                        data-target="#historyModal"
                        >History</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        href="#"
                        class="nav-link"
                        data-toggle="modal"
                        data-target="#backgroundModal"
                        >Background</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        href="#"
                        class="nav-link"
                        data-toggle="modal"
                        data-target="#rationaleModal"
                        >Rationale</a
                      >
                    </li>
                  </ul>
                </li>

                <li class="nav-item">
                  <a href="#" class="nav-link">
                    Departments
                    <i class="bx bx-chevron-down"></i>
                  </a>
                  <ul class="dropdown-menu">
                    <li class="nav-item">
                      <a
                        href="#"
                        class="nav-link"
                        data-toggle="modal"
                        data-target="#infoModal"
                        >Information And Publication</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        href="#"
                        class="nav-link"
                        data-toggle="modal"
                        data-target="#outreachModal"
                        >Programmes And Outreach</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        href="#"
                        class="nav-link"
                        data-toggle="modal"
                        data-target="#trainingModal"
                        >Recruitment And Training</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        href="#"
                        class="nav-link"
                        data-toggle="modal"
                        data-target="#entreModal"
                        >Entrepreneurship</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        href="#"
                        class="nav-link"
                        data-toggle="modal"
                        data-target="#healthModal"
                        >Health And Relationship</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        href="#"
                        class="nav-link"
                        data-toggle="modal"
                        data-target="#youthModal"
                        >Anti-Cult And Youth Restiveness</a
                      >
                    </li>
                  </ul>
                </li>

                <li class="nav-item">
                  <a href="/ipdyi-teams" class="nav-link">Team</a>
                </li>
                <li class="nav-item">
                  <a href="/contact" class="nav-link">Contact</a>
                </li>
                <li class="nav-item">
                  <a href="/" class="nav-link">City Life Centre</a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="backgroundModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            <h4>Background</h4>
            <p>
              The international purpose driven youth initiative (IPDYI), is a
              non-governmental, non-profit, non-partisan, independent,
              international, voluntary youth organisation that operates among
              secondary and tertiary schools’ students. It is devoted to helping
              the youth to clearly discover his person, potentials and purpose;
              thoroughly develop and maximally devout them for the fulfilment of
              his purpose as his contribution to the fulfilment of the overall
              purpose of mankind on earth. Furthermore, a trained youth has the
              responsibility to assist other youths to do same, that is, he is
              empowered to empower others. IPDYI is the campus arm of the
              international institute for entrepreneurship and developmental
              researches (IIEDR). The IIEDR which currently trades as business
              and leadership institute (BLI) is the parent body of PDY, but
              operates outside schools. Click to read more about BLI. IPDYI is
              duly registered in some secondary schools and universities in
              Nigeria and Botswana and seeks to conquer more grounds.
            </p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="rationaleModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            <h4>Rationale</h4>
            <p>
              The only constant in life is change, and this impacts every
              individual. Change is the essence of life in time-an interruption
              in eternity. Life on earth is governed by principles and laws. Our
              ignorance of these laws or inability to keep pace with these
              principles and laws, times, seasons and changes that occur in life
              limits our relevance in life. A life lived in discovery of the
              principles and laws that govern life as a tool for discovery,
              pursuit and fulfilment of purpose-the original intent for its
              existence-is lived in relevance. Regrettably, and contrary to
              expectations, religious organisations, governmental policies and
              prevailing socio-cultural platforms (norms and practices), have
              failed to furnish the youth with knowledge and character strengths
              requisite for purposeful living. Unfortunately, in African over
              80% of her youths will misunderstand purpose thus, live through
              life in confusion and shallowness, hunger, poverty and
              unemployment, if unassisted. At least 70 million young people
              enter the labour force in developing countries annually. Schools,
              every year, churn out high volume of young skilful people that
              must find expression for their natural and acquired endowments but
              unfortunately, over 60 percent of these are unemployed (NBS,
              2006). Furthermore, there are dwindling ‘employee’ opportunities
              being that economic growth to enable absorption of labour is
              unforeseeable. Unemployment is described as being out of job or
              work. But purpose is God-given work to an individual. Thus,
              purposeful living is the way out of youth unemployment. The youth
              must clearly discover his person, natural potentials and purpose;
              fully develop potentials and maximally harness and devout them for
              the achievement of his purpose in life. The youth must develop
              entrepreneurial spirit and skills not just as a survival strategy
              but as a lifestyle. In developing entrepreneurial skills, the
              youth must transform his personality, through value
              re-orientation, into a world-wise, globally-minded, purpose-driven
              individual. IPDYI aspires to fill these vacuums by providing the
              youth with a platform upon which he can discover and fulfil
              purpose. Of course, IPDYI does not promise to create jobs that
              shall accommodate all the unemployed. However, we are sure to help
              every youth who comes in contact with us to develop requisite
              entrepreneurial skills for self-reliance. We partner with national
              and international government and non-government organisations to
              network the youth to the rest of the world.
            </p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="historyModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            <h4>History</h4>
            <p>
              From his early days Dr. Goodhead observed that many young people
              of his age lived in emptiness, which they tried to fill with good
              things of life but to no avail. This bothered him, particularly
              because these people always asked him for advice and direction for
              their lives. Of course, he did not have ready-made answers;
              neither does he have the answers today. As more and more persons
              asked him questions he was driven to seek direction and ask
              several soul-searching questions. Discussions with his counselees
              turned into small groups of homogenous people facing similar life
              challenges. By 1995 as a leader of a Christian group Dr. Goodhead
              counseled many young people for diverse challenges. He realized
              that the high and mighty that were the envy of everyone as well as
              the poor and lowly had this emptiness lurking within; they all had
              one thing in common-the search for purpose. Finally, he came to
              the conclusion that “a life lived outside pursuit and fulfillment
              of purpose was empty”. In the wake of 2001, Dr. Goodhead founded
              the Rhema Children’s Centre (RCC); a non-denominational children’s
              club that was dedicated to helping young children and teenagers to
              find direction for their lives. During the periods of 2001 to 2006
              RCC conducted singly and in partnership with other Children’s
              groups, several Children’s programs particularly during the long
              vacation periods in Nigeria. By 2004, Dr Goodhead assisted a group
              of young undergraduate female singers to master their lines in
              music. This group continued meeting with him for training until it
              turned into Daughters of Virtue and Excellence (DOVE) Summit- a
              group that was devoted to helping young female undergraduates
              derive trust and value in themselves. By 2006, the male
              counterparts of these students protested that the group should
              expand to accommodate them. In response the group embraced the
              male counterparts and gradually transited to a friendship and
              empowerment group called Purpose Driven Youth. By 2009, PDY
              ratified and adopted her first constitution; same year that the
              group was first registered in the University of Nigeria, Nsukka
              Campus. Over the years the group has spread to many other campuses
              of Secondary and Tertiary institutions in Nigeria. PDY turned to
              become International Purpose Driven Youth Initiatives in 2014,
              when they made their debut outreach beyond the shores of Nigeria.
            </p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="infoModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            <h4>Information And Publication</h4>
            <p>
              The role of this department is to:
            </p>
            <ol>
              <li>
                Source information necessary for the smooth operations of IPDYI
                and makes same available to the other requiring departments and
                units
              </li>
              <li>
                Serve as the Corporate Affairs management unit of IPDYI- (Public
                Relation Office)
              </li>
              <li>
                Organise for and oversee the development and smooth functioning
                of the IPDYI websites, portals, database systems
              </li>
              <li>
                Organise for production and sales of IPDYI Audio and Video CDs,
                films, magazines
              </li>
              <li>
                Operate in any other capacity as deemed fit by the executive
                council and Directors of IPDYI
              </li>
            </ol>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="outreachModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            <h4>Programmes And Outreach</h4>
            <p>
              The role of this department is to:
            </p>
            <ol>
              <li>
                Envision the needs of the youths in our target area at a
                particular time
              </li>
              <li>Package an outreach to meet those needs</li>
              <li>
                Seek out sponsorship for execution of the outreach and can pass
                bills for sponsorship of programmes in a IPDYI floor meeting
              </li>
              <li>
                Work in concert with all ad-hoc or standing committees of IPDYI
                to organise, executive and oversee all IPDYI programmes
              </li>
              <li>
                Produce an outreach report and submits same to the executive
                committee of IPDYI who in turn ratifies and forwards to
                directors for final approval and ensures that the approved
                report is mass produced and made available to all appropriate
                quarters of IPDYI
              </li>
              <li>
                Receive invitations for programmes from external organisations
                and ensures adequate participation of members as deed fit by the
                executive council
              </li>
              <li>
                Regulate and ensure participation of visitors and special
                invitees to all IPDYI programmes and
              </li>
              <li>
                Operate in any other capacity as deemed fit by the executive
                council and Directors of IPDYI.
              </li>
            </ol>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="trainingModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            <h4>Recruitment And Training</h4>
            <p>
              The role of this department is to:
            </p>
            <ol>
              <li>
                Scout out for youth who need the services of IPDYI, whether they
                are members or not and offers the same service as they need.
              </li>
              <li>
                Conduct interviews and auditions for recruitment of new members
              </li>
              <li>
                Organise and conducts training on basic and advanced training
                programmes of IPDYI for all registered and untrained members and
                awards certificate of training to the same participants
              </li>
              <li>
                Organise in concert with programmes special programmes and
                conferences as deemed needful by the members
              </li>
              <li>
                Operate in any other capacity as deemed fit by the executive
                council and Directors of IPDYI
              </li>
            </ol>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="entreModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            <h4>Entrepreneurship</h4>
            <p>
              The role of this department is to:
            </p>
            <ol>
              <li>Scout out, organise and manage enterprises under IPDYI;</li>
              <li>
                Organises in concert with other IPDYI committees and departments
                training in life skill and business for members and non-members
                of IPDYI;
              </li>
              <li>
                Can partner with other business companies on behalf of IPDYI to
                run entrepreneurial ventures.
              </li>
              <li>
                Operates in any other capacity as deemed fit by the executive
                council and Directors of IPDYI.
              </li>
            </ol>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="healthModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            <h4>Health And Relationship</h4>
            <p>
              The role of this department is to:
            </p>
            <ol>
              <li>
                Organise training Sessions on HIV-AIDS matters in Secondary and
                Tertiary institution
              </li>
              <li>
                Develop and produce facts and other instructional materials on
                HIV-AIDS.
              </li>
            </ol>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="youthModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            <h4>Anti-Cult And Youth Restiveness</h4>
            <p>
              The role of this department is to:
            </p>
            <ol>
              <li>
                Conducts a search within their catchment area to scout out cult
                laddered communities and areas filled with sex workers
              </li>
              <li>
                Organises IPDYI outreaches in concert with the Outreach unit to
                such localities
              </li>
              <li>
                Organises and executes a re-integration programme for
                ex-convicts, ex-cultist, and ex- sex workers
              </li>
              <li>
                Works in agreement with Outreach department to organise and
                execute “Echoes of Eternity” annually
              </li>
            </ol>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Navbar Area -->
</template>

<script>
import logo from "../../../../public/assets/img/ipdyilogo.png";

export default {
  name: "Navbar",
  data() {
    return {
      logo: logo,
      home: "/ipdyi",
      src:
        "https://docs.google.com/forms/d/e/1FAIpQLSdM6HhRloSIC-esVhVN7sQTJ1TpRbidrJdqOXg-GhwB1Jpo6A/viewform"
    };
  }
};
</script>

<style scoped></style>
